<!-- @format -->

<ng-container *transloco="let t">
  <sis-button type="button" [size]="'sm'" data-cy="create-custom-study-draft-button" (clicked)="createNewCustomStudyDraft()"
    >{{ t("FREE_EDIT.ADD_NEW_CUSTOM_STUDY_DRAFT") }}
  </sis-button>
</ng-container>
